import DotIcon from './DotIcon';

export default DotIcon;
